import { Quiz, QuizAttempt, QuizAttemptSubmission } from "@/shared/types/Quiz";
import api from "../api.client";

const BASE_URL = "/courses";

const CoursesService = {
        getQuizzes: async (courseId: number, moduleId: number, signal?: AbortSignal): Promise<Quiz[]> => {
                return api.get<Quiz[]>(`${BASE_URL}/${courseId}/modules/${moduleId}/quiz`, { signal });
        },
        getQuiz: async (courseId: number, moduleId: number, quizId: number, userId: string, signal?: AbortSignal): Promise<Quiz> => {
                return api.get<Quiz>(`${BASE_URL}/${courseId}/modules/${moduleId}/quiz/${quizId}`, { signal, params: {userId} });
        },
        submitQuizAttempt: async (courseId: number, moduleId: number, quizId: number, payload: QuizAttemptSubmission, signal?: AbortSignal) => {
                return api.post<QuizAttemptSubmission>(`${BASE_URL}/${courseId}/modules/${moduleId}/quiz/${quizId}/submit`, payload, { signal });
        },
        getQuizAttempts: async (courseId: number, moduleId: number, quizId: number, userId: string, signal?: AbortSignal): Promise<QuizAttempt[]> => {
                return api.get<QuizAttempt[]>(`${BASE_URL}/${courseId}/modules/${moduleId}/quiz/${quizId}/attempts`, { signal, params: { userId } });
        },
        getQuizAttemptById: async (courseId: number, moduleId: number, quizId: number, attemptId: number, userId: string, signal?: AbortSignal): Promise<QuizAttempt> => {
                return api.get<QuizAttempt>(`${BASE_URL}/${courseId}/modules/${moduleId}/quiz/${quizId}/attempts/${attemptId}`, { signal, params: { userId } });
        }
};

export default CoursesService;
